import React from "react";
import { useTranslation } from "react-i18next";
import { Listbox } from "../shared/form/Listbox";
import "./LanguageSwitcher.css";

interface Language {
  id: number;
  name: string;
  code: string;
}

const LANGUAGES: Language[] = [
  { id: 1, name: "English", code: "en" },
  { id: 2, name: "Português", code: "pt" },
  { id: 3, name: "Français", code: "fr" },
  { id: 4, name: "Español", code: "es" },
  { id: 5, name: "Italiano", code: "it" },
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLanguage = LANGUAGES.find((lang) => lang.code === i18n.language) || LANGUAGES[0];

  const handleLanguageChange = (language: Language | null) => {
    if (language) {
      i18n.changeLanguage(language.code);
    }
  };

  return (
    <div className="language-switcher">
      <Listbox
        data={LANGUAGES}
        value={currentLanguage}
        onChange={handleLanguageChange}
        displayField="name"
        placeholder="Select language"
        className="language-switcher-listbox"
      />
    </div>
  );
};

